import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PAGE_ROLES } from '../../config/roleAccess';
import './TopNavigation.css';

const TopNavigation = ({ userRole, isOpen, onToggle }) => {
  const location = useLocation();

    // Navigation items with role-based access
  const navigationItems = [
    {
      path: '/dashboard',
            label: 'Overview',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="3" width="7" height="7" />
                    <rect x="14" y="3" width="7" height="7" />
                    <rect x="14" y="14" width="7" height="7" />
                    <rect x="3" y="14" width="7" height="7" />
                </svg>
            ),
            roles: PAGE_ROLES.dashboard
    },
    {
            path: '/scenario-planning',
            label: 'Scenario Planning',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                     <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                     <polyline points="3.27,6.96 12,12.01 20.73,6.96" />
                     <line x1="12" y1="22.08" x2="12" y2="12" />
                </svg>
            ),
      roles: PAGE_ROLES.scenarioPlanning
    },
    {
            path: '/production',
            label: 'Product Dashboard',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 2L2 7l10 5 10-5-10-5z" />
                    <path d="M2 17l10 5 10-5" />
                    <path d="M2 12l10 5 10-5" />
                </svg>
            ),
      roles: PAGE_ROLES.productDashboard
    },
    {
            path: '/inventory-overview',
            label: 'Inventory Manager',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 2L2 7l10 5 10-5-10-5z" />
                    <path d="M2 17l10 5 10-5" />
                    <path d="M2 12l10 5 10-5" />
                </svg>
            ),
      roles: PAGE_ROLES.inventoryManager
    },
    {
            path: '/financial-analysis',
            label: 'Financial Analysis',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="12" y1="2" x2="12" y2="22" />
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                </svg>
            ),
            roles: PAGE_ROLES.financialAnalysis
    },
      {
          path: '/production-plans',
          label: 'Production Plans',
          icon: (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                  <line x1="8" y1="14" x2="16" y2="14" />
                  <line x1="8" y1="18" x2="13" y2="18" />
              </svg>
          ),
          roles: PAGE_ROLES.productionPlans
      }
  ];

  const filteredItems = navigationItems.filter(item =>
    item.roles.includes(userRole)
  );

  return (
    <nav className={`top-navigation ${isOpen ? 'open' : ''}`}>
      <div className="nav-overlay" onClick={onToggle}></div>
      <ul className="nav-list">
        {filteredItems.map((item) => (
          <li key={item.path} className="nav-item">
              <Link
                to={item.path} 
              className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => window.innerWidth <= 768 && onToggle()}
              >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
              </Link>
          </li>
            ))}
      </ul>
    </nav>
  );
};

export default TopNavigation;